/**
 * Labstep
 */

import type { SmartTableColDef } from 'labstep-web/grid/SmartTableProtocolCondition/coldefs/types';
import { GridSmartTableColumnHeader } from 'labstep-web/grid/SmartTableProtocolCondition/components/ColumnHeader';
export const colDefProtocolConditionAddColumn =
  (): SmartTableColDef => {
    return {
      headerName: 'Add Column',
      colId: 'add_column',
      lockPosition: 'right',
      pinned: 'right',
      cellStyle: { paddingLeft: 0, paddingRight: 0 },
      resizable: false,
      headerComponent: GridSmartTableColumnHeader,
      headerComponentParams: {
        icon: 'plus',
        isAddColumn: true,
      },
    };
  };
